// extracted by mini-css-extract-plugin
export default {"root":"FAQ_root__Do6dJ","actionBtns":"FAQ_actionBtns__5SArh","title":"FAQ_title__rcgnw"};